import '../css/pages/partial-pages.css';
function PortfolioArchive(){

  return(
    <section className="easter-egg">
      <h4>Previous Versions of Portfolio Page</h4>
      <p>Under construction</p>
    </section>
  );
}
export default PortfolioArchive;